export const VERSION: string = "2.1.1-beta1";
